import React from 'react'
import docIcon from 'imgs/DOCX.png'
import pdfIcon from 'imgs/PDF.png'
import pptIcon from 'imgs/PPT.png'
import xslIcon from 'imgs/XSL.png'
import otherIcon from 'imgs/OTHERS.png'
import { saveAs } from 'file-saver'

import 'stylesheets/MainAppStyles/NoteFile.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faXmark } from '@fortawesome/free-solid-svg-icons'
import { useDeleteFile } from 'hooks/notes'

const NoteFile = ({ editMode = true, loadedFiles, setLoadedFiles, filePath, fileName, ext, id }) => {
    const { deleteComment } = useDeleteFile(id)

    const handleDownloadClick = async () => {
        try {
            const response = await fetch(filePath)
            const blob = await response.blob()
            saveAs(blob, fileName)
        } catch (error) {
            console.error("Error al descargar:" + error)
        }
    }

    const updateLoadedFiles = (loadedFiles, id) => {
        return loadedFiles.filter(loadedFile => loadedFile.id !== id);
    }


    const handleDeleteClick = (e) => {
        e.stopPropagation()
        deleteComment()
        const newLoadedFiles = updateLoadedFiles(loadedFiles, id)
        setLoadedFiles(newLoadedFiles)
    }

    let icon;
    switch (ext) {
        case 'pdf':
            icon = pdfIcon
            break;
        case 'vnd.openxmlformats-officedocument.wordprocessingml.document':
            icon = docIcon
            break;
        case 'vnd.openxmlformats-officedocument.presentationml.presentation':
            icon = pptIcon
            break;
        case 'vnd.openxmlformats-officedocument.spreadsheetml.sheet':
            icon = xslIcon
            break;
        default:
            icon = otherIcon
            break;
    }
    return (
        <div onClick={handleDownloadClick} className='note-file'>
            {editMode ? <button onClick={handleDeleteClick} className='note-button-close'><FontAwesomeIcon icon={faXmark} /></button> : ''}
            <img className='note-file-icon' src={icon} alt="file-icon" />
            <p className='note-file-name'>{fileName}</p>
        </div>
    )
}

export default NoteFile